/**
 * The SecurOne screens, in the order they are shown.
 *
 * One list, because there are two places that render it — the tab bar in
 * `SecurOne.vue` and the section in the sidebar — and they had drifted: the
 * sidebar was missing the free-text alarm, the two used different icons for the
 * same screen, and the sidebar's category entry did not stay highlighted while a
 * broadcast was being confirmed.
 *
 * `when` names a store getter that has to be true for the entry to exist. Only
 * the tab bar honours it: the sidebar renders outside the module and does not
 * load its context, so an entry that depends on it would flicker in as soon as
 * somebody opened SecurOne and out again on the next reload. Conditional entries
 * are therefore tab-bar only, which is also where they belong — they are things
 * you do, not places you go.
 */
// Frozen, because two components put this same list in their `data()`: Vue 2
// skips frozen objects instead of making them reactive, so neither can mutate
// the other's entries and neither pays for observers on static config.
const entry = (item) => Object.freeze({ ...item, match: Object.freeze(item.match) });

export const NAV = Object.freeze([
  { name: "securone_overview", label: "overview", icon: "th-large", match: ["securone_overview"] },
  {
    name: "securone_categories",
    label: "categories",
    icon: "exclamation-triangle",
    match: ["securone_categories", "securone_category_new", "securone_category_edit", "securone_broadcast"],
  },
  { name: "securone_freetext", label: "freetext", icon: "bullhorn", match: ["securone_freetext"], when: "canRaiseFreeText" },
  { name: "securone_groups", label: "groups", icon: "users", match: ["securone_groups", "securone_group_new", "securone_group_edit"] },
  { name: "securone_users", label: "users", icon: "user", match: ["securone_users"] },
  { name: "securone_documents", label: "documents", icon: "file", match: ["securone_documents"] },
  { name: "securone_events", label: "events", icon: "history", match: ["securone_events", "securone_event"] },
].map(entry));

/** The entries that need no module context — what the sidebar renders. */
export const ALWAYS_VISIBLE_NAV = Object.freeze(NAV.filter((item) => !item.when));

export default NAV;
